// src/utils/formatUtils.ts

/**
 * Formats a number by rounding it to the nearest integer, separating thousands with spaces,
 * and prepending an "almost equal to" sign if rounding occurs.
 * @param num The number to format.
 * @returns The formatted number as a string, with an "almost equal to" sign if it was rounded.
 */

export const formatNumberWithSpacesAndRounding = (num: number): string => {
	const roundedNum = Math.round(num);
	const isRounded = num !== roundedNum;
	const formattedNumber = roundedNum.toLocaleString('en-US').replace(/,/g, ' ');

	return `${isRounded ? '≈ ' : ''}${formattedNumber}`;
};

export const getSingularOrPluralCode = (num: number, singularStrCode: string, pluralStrCode: string): string => {
	return num === 1 ? singularStrCode : pluralStrCode;
}

export const formatDateToYmd = (date: Date): string => {
	const year = date.getFullYear();
	// getMonth returns a zero-based value, so we add 1
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};